import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILogDestination, LogMessageType, ServerRootService } from '@se/se.ui.html5';
import { constant, noop } from 'lodash-es';
import { firstValueFrom } from 'rxjs';

export interface ILogData {
    message: string;
    severity: LogMessageType;
    timestamp: string;
    uid: string;
}

@Injectable({
    providedIn: 'root',
})
export class LogService extends ServerRootService implements ILogDestination {
    private readonly apiController: string;

    constructor(private httpClient: HttpClient) {
        super();

        this.apiController = `${this.getServerRoot()}/Log`;

        window.addEventListener('error', evt => this.logErrorEvent(evt));
    }

    canHandle(type: LogMessageType) {
        return type !== LogMessageType.Trace && type !== LogMessageType.Debug;
    }

    log(type: LogMessageType, message: any, uid?: string): Promise<void> {
        if (!navigator.onLine) {
            return;
        }

        let serializedMessage: string = '';
        if (message instanceof Error) {
            serializedMessage = message.message;
        } else {
            try {
                serializedMessage = JSON.stringify(message);
            }
            catch {
                serializedMessage = message.toString();
            }
        }

        const logMessage: ILogData = {
            message: serializedMessage,
            severity: type,
            timestamp: new Date().toISOString(),
            uid,
        };

        return firstValueFrom(this.httpClient.post(`${this.apiController}/SeLog`, logMessage))
            /* Ignora gli errori di log. */
            .catch(noop)
            .then(constant(null));
    }

    private logErrorEvent(evt: ErrorEvent) {
        const message = `${evt.message} at ${evt.filename}:${evt.lineno}:${evt.colno}`;

        this.log(LogMessageType.Error, message);
    }
}
